

































































import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
@Component({
  components: {},
})
export default class MyDialog extends Vue {
  @Prop({ default: false }) value: boolean;
  @Prop({ default: "" }) title: string;
  @Prop({ default: "" }) content: string;
  @Prop({ default: "" }) okText: string;
  @Prop({ default: "" }) cancelText: string;
  @Prop({ default: false }) confirm: boolean;
  @Prop({ default: true }) closeButton: boolean;

  get show() {
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }

  @Emit()
  onShow() {
    return;
  }

  @Emit()
  onHide() {
    return;
  }

  @Watch("show")
  onShowWatch(val) {
    if (val) {
      this.onShow();
    }
  }
}
